import React from 'react';
import UnifiedSimpleConversionExplanation from './UnifiedSimpleConversionExplanation';

const WeightConversionExplanation = ({
  fromUnit,
  toUnit,
  inputValue,
  result,
  darkMode
}) => {
  const getConversionData = () => {
    // Kilograms to other units
    if (fromUnit === 'Kilograms' && toUnit === 'Pounds') {
      return {
        formula: 'lb = kg × 2.20462',
        conversionSteps: [
          `Take the weight in kilograms: ${inputValue}kg`,
          `Multiply by 2.20462: ${inputValue} × 2.20462 = ${result}lb`
        ],
        realWorldExample: "A 75kg person weighs approximately 165 pounds.",
        funFacts: [
          "The kilogram is the only SI unit still defined by a physical object.",
          "The pound was derived from the Roman 'libra' (hence the abbreviation 'lb').",
          "The average adult male weighs about 80kg (176 lbs).",
        ]
      };
    }

    if (fromUnit === 'Grams' && toUnit === 'Ounces') {
      return {
        formula: 'oz = g × 0.035274',
        conversionSteps: [
          `Take the weight in grams: ${inputValue}g`,
          `Multiply by 0.035274: ${inputValue} × 0.035274 = ${result}oz`
        ],
        realWorldExample: "A slice of bread weighs about 25 grams or 0.88 ounces.",
        funFacts: [
          "The word 'ounce' comes from the Latin 'uncia', meaning 'twelfth part'.",
          "A paperclip weighs about 1 gram.",
          "A US quarter weighs exactly 5.67 grams.",
        ]
      };
    }

    // Add more common conversions...
    return {
      formula: `Converting from ${fromUnit} to ${toUnit}`,
      conversionSteps: [
        `Start with ${inputValue} ${fromUnit}`,
        `Apply conversion factor`,
        `Result: ${result} ${toUnit}`
      ],
      realWorldExample: "Weight conversions are crucial in cooking, shipping, and personal health monitoring.",
      funFacts: [
        "Weight and mass are different - weight is affected by gravity, mass isn't.",
        "The metric system makes weight conversion easy with base-10 relationships.",
        "Different industries often prefer different weight units.",
      ]
    };
  };

  const conversionData = getConversionData();

  return (
    <UnifiedSimpleConversionExplanation
      conversionType="weight"
      fromUnit={fromUnit}
      toUnit={toUnit}
      inputValue={inputValue}
      result={result}
      darkMode={darkMode}
      {...conversionData}
    />
  );
};

export default WeightConversionExplanation; 